import React from 'react';
import ReactPaginate from 'react-paginate';
import {useLoaderData, Await, useNavigate, useLocation} from '@remix-run/react';

//domains
import {loader} from '~/routes/($lang)/collections/$collectionHandle';
import {
  filterInputToParams,
  PRODUCT_PER_PAGE,
  PRODUCT_PER_PAGE_WITHOUT_ADS,
} from 'domains/collections';

export default function CollectionPagination() {
  const {totalProducts, hasAds, translation} = useLoaderData<typeof loader>();
  const productPerPage = hasAds
    ? PRODUCT_PER_PAGE
    : PRODUCT_PER_PAGE_WITHOUT_ADS;
  const pageCount = Math.ceil(totalProducts / productPerPage);

  const location = useLocation();
  const params = React.useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );
  const navigate = useNavigate();

  return (
    <div className="mb-20 collection-pagination hidden lg:block">
      <ReactPaginate
        breakLabel="..."
        nextLabel={translation.next ? `${translation.next} >` : 'next >'}
        onPageChange={(e) => {
          const nextPage = e.selected + 1;
          const newParams = filterInputToParams(
            'PAGE',
            {nextPage},
            params,
            'page',
          );
          navigate(`${location.pathname}?${newParams.toString()}`);
        }}
        pageRangeDisplayed={5}
        pageCount={pageCount}
        previousLabel={translation.previous ? `< ${translation.previous}` : "< previous"}
        renderOnZeroPageCount={null}
        marginPagesDisplayed={0}
      />
    </div>
  );
}
